module.exports = __webpack_public_path__ + "img/capa2.e34fe345.webp";